import { useState } from "react";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { useTranslate } from "@/hooks";
import { colorGreen, colorPrimary, colorRed } from "@/constants/colors";
import ButtonIcon from "../ButtonIcon/ButtonIcon";
import { IButtonCopyToClipboardProps } from "./ButtonCopyToClipboard.props";

const ButtonCopyToClipboard = ({ text, title = "button_copy" }: IButtonCopyToClipboardProps): JSX.Element => {
	const [iconColor, setIconColor] = useState<string>(colorPrimary);
	const translate = useTranslate(); // hook для перевода текста

	const returnDefaultColor = (): void => {
		setTimeout(() => {
			setIconColor(colorPrimary);
		}, 2000);
	};

	async function copyToClipboard(text: string) {
		try {
			await navigator.clipboard.writeText(text);
			setIconColor(colorGreen);
			returnDefaultColor();
		} catch (err) {
			setIconColor(colorRed);
			returnDefaultColor();
		}
	}

	return <ButtonIcon icon={faCopy} iconSize="lg" iconColor={iconColor} onClick={() => copyToClipboard(text)} title={translate(title)} />;
};

export default ButtonCopyToClipboard;
